import $ from 'jquery';
import 'slick-carousel';

function initCarousel1Slider() {
	let slides = $('.carousel-1 .slides');

	if (slides.length && slides.find('.slide-2').length) {
		slides.not('.slick-initialized').slick({
			arrows: true,
			autoplay: true,
			autoplaySpeed: 7500,
			dots: false,
			nextArrow:
				'<div class="slick-next"><i class="fa-regular fa-arrow-right-long"></i></div>',
			pauseOnHover: false,
			pauseonFocus: false,
			prevArrow:
				'<div class="slick-prev"><i class="fa-regular fa-arrow-left-long"></i></div>',
			speed: 1000,
		});
	}
}

function initCarousel2Slider() {
	let slider = $('.carousel-2 .slider');

	slider.on('init', function () {
		if ($(window).height() > 960) {
			$('.carousel-2 .slider .slide-2').find('.caption').addClass('active');
		}
	});

	slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
		if ($(window).height() > 960) {
			let next = currentSlide + 1;
			$('.carousel-2 .slider').find('.caption').removeClass('active');
			$('.carousel-2 .slider .slick-slide[data-slick-index="' + next + '"]')
				.find('.caption')
				.addClass('active');
		}
	});

	if (slider.length && slider.find('.slide-2').length) {
		slider.not('.slick-initialized').slick({
			arrows: true,
			autoplay: true,
			autoplaySpeed: 7500,
			dots: false,
			infinite: true,
			nextArrow:
				'<div class="slick-next"><i class="fa-regular fa-arrow-right-long"></i></div>',
			pauseOnHover: false,
			pauseonFocus: false,
			prevArrow:
				'<div class="slick-prev"><i class="fa-regular fa-arrow-left-long"></i></div>',
			slidesToShow: 3,
			slidesToScroll: 1,
			speed: 1000,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						infinite: true,
						dots: true,
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	}
}

$(window).on('load', function () {
	initCarousel1Slider();
	initCarousel2Slider();
});
